module.exports = require("@swa-ui/shopping/src/PassengerSelector/PassengerSelector.module.scss");